import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';

interface MichrazInfoCard {
	// _id: Number;
	MichrazName: String;
	// StatusMichraz: Number;
	// KodYeudMichraz: Number;
	// KodYeshuv: Number;
	YechidotDiur: Number;
	Shchuna: String;
	// PirsumDate: Date;
	// PtichaDate: Date;
	SgiraDate: Date;
	// VaadaDate: Date;
	// SiyurDate: Date;
	// KodSugMichraz: Number;
	// UpdateDate: Date;
	// HagashaMekuvenet: Boolean;
	// Location: any;

	YeudMichrazText: String;
	YeshuvText: String;
	SugMichrazText: String;
	// StatusMichrazText: String;
	isSelected: Boolean;
}

export default function OpenOccCard(props: MichrazInfoCard) {
	const {
		isSelected,
		MichrazName,
		YeshuvText,
		SugMichrazText,
		Shchuna,
		YechidotDiur,
		YeudMichrazText,
		SgiraDate
	} = props;

	const theme = useTheme();

	return (
		<Card
			sx={{
				cursor: 'pointer',
				background: isSelected ? '#F0FFF0' : null,
				display: 'flex',
				marginLeft: '0px',
				marginRight: '0px',
				marginBottom: '0px',
				boxShadow: 'none',
				width: '200px',
			}}
			onClick={() => {
				console.log('card click');
			}}
		>
			<Box
				m={0}
				sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
			>
				<CardContent
					sx={{
						flex: '1 0 auto',
						padding: '0px',
						'&:last-child': {
							paddingBottom: 0,
						},
					}}
				>
					<Typography component="div" variant="body1">
						{MichrazName} |{YeshuvText} |{SugMichrazText} |
						{Shchuna} | {YechidotDiur} יח”ד
					</Typography>
					<Typography variant="body2" color="text.secondary" component="div">
						{YeudMichrazText} | | מועד אחרון: | {SgiraDate} | (עוד 3
						ימים)
					</Typography>
					<Typography component="div" variant="body2">
						למידע נוסף
					</Typography>
				</CardContent>
			</Box>
			{/* <CardMedia
				component="img"
				sx={{ width: 151 }}
				image="/static/images/cards/live-from-space.jpg"
				alt="Live from space album cover"
			/> */}
		</Card>
	);
}
